






























import { Vue, Component } from 'vue-property-decorator'

@Component({ name: 'onboard-option' })
export default class Option extends Vue {}
